module.exports = __webpack_public_path__ + "static/media/error.b9d1096a.svg";